import React from 'react'
import { ImageViewportSizes, LayoutValue } from '../components/ui-lib/image/types'
import { breakpoints } from '../components/ui-lib/breakpoints'

interface LayoutWithSizes {
  layout?: Extract<LayoutValue, 'fill' | 'responsive'>
  sizes?: ImageViewportSizes
}

interface LayoutWithoutSizes {
  layout?: Extract<LayoutValue, 'intrinsic' | 'fixed'>
  sizes?: never
}

export type IImageContext = LayoutWithSizes | LayoutWithoutSizes

export const ImageContext = React.createContext<IImageContext>({})

// Context for identifying GrammarlyAtWork25 sections for custom styling
export interface IGrammarlyAtWork25Context {
  isGrammarlyAtWork25: boolean
}

export const GrammarlyAtWork25Context = React.createContext<IGrammarlyAtWork25Context>({
  isGrammarlyAtWork25: false,
})

// The browser can request the appropriate width for the image based on sizes and device pixel ratio.
// Sizes attribute for responsive images shown in different types of sections

export const heroSectionResponsiveImageProps: IImageContext = {
  sizes: `(max-width: ${breakpoints.xsmall}) 100vw, 50vw`,
  layout: 'responsive',
}

export const oneColSectionResponsiveImageProps: IImageContext = {
  sizes: '100vw',
  layout: 'responsive',
}

// Upto a max-width of 'breakpoints.xsmall', an image of width 100vw will be retrieved
// For screen sizes bigger than the breakpoint, retrieve images of 50vw size
export const twoColSectionResponsiveImageProps: IImageContext = {
  sizes: `(max-width: ${breakpoints.xsmall}) 100vw, 50vw`,
  layout: 'responsive',
}

export const multiColSectionResponsiveImageProps: IImageContext = {
  sizes: `(max-width: ${breakpoints.xsmall}) 100vw, 33vw`,
  layout: 'responsive',
}

// Enhanced image properties for GrammarlyAtWork25 hero with larger sizing
export const grammarlyAtWork25HeroImageProps: IImageContext = {
  sizes: `(max-width: ${breakpoints.xsmall}) 100vw, 33vw`, // Increased from 50vw to 60vw
  layout: 'responsive',
}
